import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import { gioiTinhApi } from '../../api/gioiTinhApi';
import { namHocAPi } from '../../api/namHocApi';
import { useCommonContext } from '../../contexts/common';

const ComboboxGioiTinh = ({ value, onValueChanged, cmb, width }) => {
  const { translate } = useCommonContext();

  const [dm_gioitinhs, set_dm_gioitinhs] = useState([]);
  useEffect(() => {
    handleReload();
  }, []);
  const handleReload = async () => {
    const res = await gioiTinhApi.SelectAll();
    if (res.is_success) {
      set_dm_gioitinhs(res.data);
    }
  };
  return (
    <SelectBox
      dataSource={dm_gioitinhs}
      displayExpr={'gioi_tinh'}
      valueExpr={'id'}
      placeholder={translate('Chọn giới tính')}
      value={value}
      stylingMode="outlined"
      width={width || 120}
      ref={cmb}
      onValueChanged={(e) => {
        if (e.event) onValueChanged(e.value);
      }}
    />
  );
};

export default ComboboxGioiTinh;
